import { useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import { ShieldCheck, Mail, Smartphone, KeyRound } from "lucide-react";
import Modal from "../Modal";
import { concealEmail, concealPhoneNumber } from "../utils/2FA-utils/conceal";
import { ResendCode } from "../utils/2FA-utils/resendOtp";


function TwoFactorAuth({ onClose, handleConfirmTransfer, notificationChannel, recipient, errorMessage }) {
  const [areFieldsSet, setAreFieldsSet] = useState(false);
  const [otp, setOtp] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    setAreFieldsSet(otp.length === 6);
  }, [otp]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!areFieldsSet || isProcessing) return;
    
    setIsProcessing(true);
    await handleConfirmTransfer(e);
    setIsProcessing(false);
  };

  // Icon and masked destination based on where the OTP was sent.
  const { Icon, destination } = {
    email: { Icon: Mail, destination: concealEmail(recipient) },
    phone: { Icon: Smartphone, destination: concealPhoneNumber(recipient) },
  }[notificationChannel] || { Icon: KeyRound, destination: null };

  return (
    <section>
      <Modal
        showModal={true}
        setShowModal={onClose}
        showCloseButton={false}
        clickOut={false}
        closeOnEscape={false}
        noPadding
        maxWidth={440}
      >
        <div
          className="modal-header border-0 p-4 d-flex align-items-center justify-content-center gap-2"
          style={{ background: "#0F5C30" }}
        >
          <ShieldCheck size={18} color="#fff" />
          <h2
            className="mb-0"
            id="modalExampleTitle"
            style={{ fontSize: "0.95rem", fontWeight: 600, color: "#fff" }}
          >
            Two-Factor Authentication
          </h2>
        </div>

        <div className="modal-body px-5 pt-5 pb-4 text-center">
          <div
            className="d-flex align-items-center justify-content-center rounded-circle mx-auto mb-3"
            style={{ width: 56, height: 56, background: "#E8F5E9" }}
          >
            <Icon size={24} color="#0F5C30" />
          </div>

          <p
            className="mb-1"
            style={{ fontSize: "1rem", fontWeight: 600, color: "#0d1b12" }}
          >
            Enter verification code
          </p>
          <p
            className="text-muted mb-5"
            style={{ fontSize: "0.82rem", lineHeight: 1.6 }}
          >
            For added security, we sent a 6-digit code to{" "}
            {destination ? (
              <span style={{ fontWeight: 600, color: "#0d1b12" }}>
                {destination}
              </span>
            ) : (
              "your email or phone number"
            )}
          </p>

          <form onSubmit={handleSubmit}>
            <input
              type="password"
              className="form-control text-center mb-3"
              onChange={(e) => setOtp(e.target.value.trim())}
              name="otp"
              id="otp"
              title="Numbers only, e.g. 123456"
              maxLength="6"
              required
              pattern="[0-9]{6}"
              inputMode="numeric"
              autoComplete="one-time-code"
              placeholder="••••••"
              style={{
                height: 52,
                fontFamily: "Verdana, sans-serif",
                fontSize: "1.4rem",
                letterSpacing: "0.6em",
                paddingLeft: "0.6em",
                color: "#0F5C30",
              }}
            />

            <button
              id="submit"
              className="btn w-100 btn-primary lift"
              type="submit"
              disabled={!areFieldsSet || isProcessing}
            >
              {isProcessing ? (
                <Loader type="Oval" color="#fff" width={20} height={20} />
              ) : (
                "Confirm"
              )}
            </button>

            {errorMessage && (
              <div
                className="alert alert-danger text-center mt-3 mb-0"
                role="alert"
                style={{
                  background: "#f8d7da",
                  borderColor: "#f5c6cb",
                  color: "#721c24",
                  fontSize: "0.82rem",
                }}
              >
                {errorMessage}
              </div>
            )}

            <div className="mt-4">
              <ResendCode />
            </div>
          </form>
        </div>
      </Modal>
    </section>
  );
}

export default TwoFactorAuth;
